import BookingRules from '../components/templates/booking-rules';

export const BookingRulesContainer = () => {
  return <BookingRules />;
};
